const image = {
  baguni: 37,
  fire: 29,
  fire2: 30,
  hwaduck: 31,
  hwaduck2: 32,
  gagu: 35,
  plate: 36,
  soil_gama: 33,
  stone_gama: 34,
  umul: 38,
  job_a087: 2,
  job_a088: 3,
  job_a090: 1,
  job_a111: 11,
  job_a114: 12,
  job_a116: 14,
  job_a119: 13,
  job_b087: 4,
  job_b091: 5,
  job_b095: 6,
  job_b102: 9,
  job_b104: 8,
  job_b107: 7,
  job_b108: 10,
  sub_a026: 16,
  sub_a038: 18,
  sub_a044: 19,
  sub_a055: 20,
  sub_a067: 22,
  sub_a075: 28,
  sub_a078: 26,
  sub_a080: 27,
  sub_b010: 15,
  sub_b033: 17,
  sub_b050: 21,
  sub_b062: 23,
  sub_b077: 24,
  sub_b080: 25,
};

const image_R = {
  37: "baguni",
  29: "fire",
  30: "fire2",
  31: "hwaduck",
  32: "hwaduck2",
  35: "gagu",
  36: "plate",
  33: "soil_gama",
  34: "stone_gama",
  38: "umul",
  2: "job_a087",
  3: "job_a088",
  1: "job_a090",
  11: "job_a111",
  12: "job_a114",
  14: "job_a116",
  13: "job_a119",
  4: "job_b087",
  5: "job_b091",
  6: "job_b095",
  9: "job_b102",
  8: "job_b104",
  7: "job_b107",
  10: "job_b108",
  16: "sub_a026",
  18: "sub_a038",
  19: "sub_a044",
  20: "sub_a055",
  22: "sub_a067",
  28: "sub_a075",
  26: "sub_a078",
  27: "sub_a080",
  15: "sub_b010",
  17: "sub_b033",
  21: "sub_b050",
  23: "sub_b062",
  24: "sub_b077",
  25: "sub_b080",
};

const majorImages = {
  baguni: require("../assets/images/baguni.png"),
  fire: require("../assets/images/fire.png"),
  fire2: require("../assets/images/fire2.png"),
  hwaduck: require("../assets/images/hwaduck.png"),
  hwaduck2: require("../assets/images/hwaduck2.png"),
  gagu: require("../assets/images/gagu.png"),
  plate: require("../assets/images/plate.png"),
  soil_gama: require("../assets/images/soil_gama.png"),
  stone_gama: require("../assets/images/stone_gama.png"),
  umul: require("../assets/images/umul.png"),
};

const all_Images = {
  baguni: require("../assets/images/baguni.png"),
  fire: require("../assets/images/fire.png"),
  fire2: require("../assets/images/fire2.png"),
  hwaduck: require("../assets/images/hwaduck.png"),
  hwaduck2: require("../assets/images/hwaduck2.png"),
  gagu: require("../assets/images/gagu.png"),
  plate: require("../assets/images/plate.png"),
  soil_gama: require("../assets/images/soil_gama.png"),
  stone_gama: require("../assets/images/stone_gama.png"),
  umul: require("../assets/images/umul.png"),
  job_a087: require("../assets/images/a087.jpg"),
  job_a088: require("../assets/images/a088.jpg"),
  job_a090: require("../assets/images/a090.jpg"),
  job_a111: require("../assets/images/a111.jpg"),
  job_a114: require("../assets/images/a114.jpg"),
  job_a116: require("../assets/images/a116.jpg"),
  job_a119: require("../assets/images/a119.jpg"),
  job_b087: require("../assets/images/b087.jpg"),
  job_b091: require("../assets/images/b091.jpg"),
  job_b095: require("../assets/images/b095.jpg"),
  job_b102: require("../assets/images/b102.jpg"),
  job_b104: require("../assets/images/b104.jpg"),
  job_b107: require("../assets/images/b107.jpg"),
  job_b108: require("../assets/images/b108.jpg"),
  sub_a026: require("../assets/images/a026.png"),
  sub_a038: require("../assets/images/a038.png"),
  sub_a044: require("../assets/images/a044.png"),
  sub_a055: require("../assets/images/a055.png"),
  sub_a067: require("../assets/images/a067.png"),
  sub_a075: require("../assets/images/a075.png"),
  sub_a078: require("../assets/images/a078.png"),
  sub_a080: require("../assets/images/a080.png"),
  sub_b010: require("../assets/images/b010.png"),
  sub_b033: require("../assets/images/b033.png"),
  sub_b050: require("../assets/images/b050.png"),
  sub_b062: require("../assets/images/b062.png"),
  sub_b077: require("../assets/images/b077.png"),
  sub_b080: require("../assets/images/b080.png"),
};

// const subImages = {
//   sub_a026: require("../assets/images/a026.png"),
//   sub_a038: require("../assets/images/a038.png"),
//   sub_a044: require("../assets/images/a044.png"),
//   sub_a055: require("../assets/images/a055.png"),
//   sub_a067: require("../assets/images/a067.png"),
//   sub_a075: require("../assets/images/a075.png"),
//   sub_a078: require("../assets/images/a078.png"),
//   sub_a080: require("../assets/images/a080.png"),
//   sub_b010: require("../assets/images/b010.png"),
//   sub_b033: require("../assets/images/b033.png"),
//   sub_b050: require("../assets/images/b050.png"),
//   sub_b062: require("../assets/images/b062.png"),
//   sub_b077: require("../assets/images/b077.png"),
//   sub_b080: require("../assets/images/b080.png"),
// };

const playerRed = {
  farmer: require("../assets/images/farmer_icon_red.png"),
  stable: require("../assets/images/stable_icon_red.png"),
  fence: require("../assets/images/fence_icon_red.png"),
};

const playerBlue = {
  farmer: require("../assets/images/farmer_icon_blue.png"),
  stable: require("../assets/images/stable_icon_blue.png"),
  fence: require("../assets/images/fence_icon_blue.png"),
};

const resource = {
  boar: require("../assets/images/boar_icon.png"),
  cow: require("../assets/images/cow_icon.png"),
  sheep: require("../assets/images/sheep_icon.png"),
  food: require("../assets/images/food_icon.png"),
  grain: require("../assets/images/grain_icon.png"),
  vege: require("../assets/images/vege_icon.png"),
};

export {
  image,
  image_R,
  all_Images,
  majorImages,
  // subImages,
  playerRed,
  playerBlue,
  resource,
};
